import React from 'react';
import { string,number,oneOfType} from 'prop-types';
import style from './style';

const Blank = ({text,annotation,blankSize,blankColor,...props}) => {
	return (
		<style.BlankStyle blankSize={blankSize} blankColor={blankColor} {...props}>
			<style.Annotation>
				{annotation}
			</style.Annotation>
			<style.HiddenText>
				{(annotation && annotation.length > text.length) ? annotation : text}
			</style.HiddenText>
		</style.BlankStyle>
	);
};
Blank.propTypes = {
	text: string.isRequired,
	annotation : oneOfType([
		string,
		number,
	]),
	blankColor : string
};

export default Blank;